<template>
  <div>
    <CrudGrid
      :footer-text="$t('messages.items_per_page')"
      :headers="headers"
      :items="authorization_options"
      :search="filterSearch"
      :loading="loading"
      :page="page"
      :options.sync="options"
    >
      <template v-slot:header>
        <div class="header-table">
          <CrudFilter :has-filters="hasFilters" @search="applyFilter" @clear="clearFilter">
            <v-list-item>
              <v-text-field
                color="#086318"
                label="Motivo de Recusa Familiar"
                class="rounded-lg"
                hide-details
                outlined
                dense
                v-model="filterForm.description"
              />
            </v-list-item>
            <v-list-item>
              <v-select
                :items="kind_of_donors"
                item-value="id"
                item-text="name"
                color="#086318"
                label="Tipo de Paciente"
                class="rounded-lg"
                hide-details
                outlined
                dense
                v-model="filterForm.kind_of_donor"
              />
            </v-list-item>
          </CrudFilter>
          <v-btn class="rounded-lg ml-2" elevation="1" color="#41916b" @click="openDialog()">
            <span class="textBtn">{{$t('buttons.new')}}</span>
          </v-btn>
        </div>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <Menu :resource="item" @editItemGrid="openDialog(item)">
          <ChangeStatus
            :resource="item"
            typeData="not-delete"
            @updateGrid="searchGridData()"
            url="authorization_options"
          />
        </Menu>
      </template>

      <template v-slot:[`item.status`]="{ item }">
        <v-chip :color="item.deleted_at ? '#fa5252' : '#bedfc5'" dark>
          {{ item.deleted_at ? 'Inativo' : 'Ativo' }}
        </v-chip>
      </template>
    </CrudGrid>

    <Modal v-model="dialog">
      <MotivosRecusaFamiliarForm
        :openDialog="dialog"
        :resource="resource"
        @closeDialog="dialog = false, searchGridData()"
      />
    </Modal>
  </div>
</template>

<script>
import { getReasonFamilyRefusals } from "@/service/basic-registrations/ReasonFamilyRefusalService";
import MotivosRecusaFamiliarForm from "./ReasonsFamilyRefusal.vue";
import Menu from "@/components/widgets/MenuActions-comp.vue";
import ChangeStatus from "@/components/widgets/ChangeStatus-comp.vue";
import CrudGrid from "../widgets/Grid.vue";
import CrudFilter from "../widgets/Filter.vue";
import Modal from "../widgets/Modal.vue";
import { mapActions } from "vuex";
import FormFieldsService from '@/service/FormFieldsService';

export default {
  components: {
    Menu,
    ChangeStatus,
    MotivosRecusaFamiliarForm,
    CrudGrid,
    CrudFilter,
    Modal,
  },

  data() {
    return {
      loading: false,
      dialog: false,
      filterForm: {},
      filterSearch: '',
      kind_of_donors: [],
      authorization_options: [],
      reason_not_donation_id: 1,
      page: 1,
      options: {},
      resource: {},
      headers: [
        { text: 'Motivos de Recusa Familiar', value: 'description', sortable: false },
        { text: 'Tipo de Paciente', value: 'kind_of_donor.name', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Ações', value: 'actions', sortable: false },
      ],
      actions: [
        {
          name: "Editar",
          type: "modal",
          route: "",
          encryptionName: "",
          encryptionPassword: "",
          componentName: "",
        },
      ],
    };
  },

  computed: {
    hasFilters() {
      return Object.values(this.filterForm).some(v => v != null && v !== '');
    },
  },

  async created() {
    this.searchGridData();
    this.changeActionsData(this.actions);
    this.kind_of_donors = await FormFieldsService.getKindOfDonor();
  },

  methods: {
    ...mapActions(["changeSnackBarData", "changeActionsData"]),

    openDialog(item) {
      this.resource = item || {};
      this.dialog = true;
    },

    async searchGridData() {
      this.loading = true;
      try {
        const result = await getReasonFamilyRefusals(this.reason_not_donation_id, {
          kind_of_donor_id: this.filterForm.kind_of_donor || '',
        });
        this.authorization_options = result;
        this.filterSearch = this.filterForm.description || '';
        this.loading = false;
      } catch (e) {
        this.loading = false;
        this.changeSnackBarData({
          status: true,
          type: 'erro',
          titleMessage: 'Erro ao buscar dados',
          bodyMessage: '',
          cardColor: 'red',
          titleIcon: 'mdi-close-circle',
        });
      }
    },

    applyFilter() {
      this.searchGridData();
    },

    clearFilter() {
      this.filterForm = {};
      this.filterSearch = '';
      this.searchGridData();
    },
  },
};
</script>

<style scoped>
.header-table {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.textBtn {
  font-family: "Poppins";
  color: #ffffff;
}

@media (max-width: 768px) {
  .header-table {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>
